import React, { useState } from 'react';
import { Search, ChevronDown, ChevronUp, X, Info } from 'lucide-react';
import { ChannelType, ContactStepProps } from '../types';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from 'Common/Components/Loading';

const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Adjuster Meeting', label: 'Adjuster Meeting' },
  { value: 'Capout', label: 'Cap out' },
  { value: 'Collections', label: 'Collections' },
  { value: 'Damaged - On Hold', label: 'Damaged - On Hold' },
  { value: 'Estimate', label: 'Estimate' },
  { value: 'F/U Lost', label: 'F/U Lost' },
  { value: 'Final Inspection/Walkthru', label: 'Final Inspection/Walk thru' },
  { value: 'Follow Up', label: 'Collections' },
  { value: 'Gutters', label: 'Gutters' },
  { value: 'Huston Follow Up', label: 'Huston Follow Up' },
  { value: 'In-Progress', label: 'In-Progress' },
  { value: 'In Review', label: 'In Review' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'Inspection', label: 'Inspection' },
  { value: 'Insurance Reconciliation', label: 'Insurance Reconciliation' },
  { value: 'Invoice', label: 'Invoice' },
  { value: 'Invoice Customer', label: 'Invoice Customer' },
  { value: 'Job Denied', label: 'Job Denied' },
  { value: 'Job On Hold', label: 'Job On Hold' },
  { value: 'KICK OFF', label: 'KICK OFF' },
  { value: 'Lead', label: 'Lead' },
  { value: 'Lost', label: 'Lost' },
  { value: 'No Damage', label: 'No Damage' },
  { value: 'Paid & Closed', label: 'Paid & Closed' },
  { value: 'Paid (Archive)', label: 'Paid (Archive)' },
  { value: 'Pending Final Payment', label: 'Pending Final Payment' },
  { value: 'Pending Insurance Approval', label: 'Pending Insurance Approval' },
  { value: 'Repair Request', label: 'Repair Request' },
  { value: 'Repairs', label: 'Repairs' },
  { value: 'Roof', label: 'Roof' },
  { value: 'Scheduled', label: 'Scheduled' },
  { value: 'Signed Contract', label: 'Signed Contract' },
  { value: 'Submit Warranty', label: 'Submit Warranty' },
  { value: 'Supplement/Submit Depr', label: 'Supplement/Submit Depr' },
  { value: 'Windows', label: 'Windows' },
  { value: 'Work Complete', label: 'Work Complete' },
];

const ContactStep: React.FC<ContactStepProps> = ({
  totalContacts,
  filteredContact,
  contactsSelected,
  selectAll,
  showErrorSelectContact,
  hasMore,
  loadingContacts,
  isView,
  contactsTemp,
  saleRepOptions,
  channelType,
  onLoadMore,
  handleContactSearch,
  handleSelectAll,
  handleContactSelect,
  setShowErrorSelectContact
}) => {
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [zipCode, setZipCode] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [selectedRadius, setSelectedRadius] = useState('3');
  const [status, setStatus] = useState<string[]>([]);
  const [saleRep, setSaleRep] = useState<string[]>([])
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showSaleRepDropdown, setShowSaleRepDropdown] = useState(false);



  const handleStatusChange = (statusValue: string, checked: boolean) => {
    if (checked) {
      const newStatus = [...status, statusValue];
      setStatus(newStatus);
      handleContactSearch({
        searchValue: searchValue,
        zipCode: zipCode,
        range: selectedRadius,
        status: newStatus,
        saleRep: saleRep
      });
    } else {
      const newStatus = status.filter(s => s !== statusValue);
      setStatus(newStatus);
      handleContactSearch({
        searchValue: searchValue,
        zipCode: zipCode,
        range: selectedRadius,
        status: newStatus,
        saleRep: saleRep
      });
    }
  };

  const handleSaleRepChange = (saleRepValue: string, checked: boolean) => {
    if (checked) {
      const newSaleRep = [...saleRep, saleRepValue];
      setSaleRep(newSaleRep);
      handleContactSearch({
        searchValue: searchValue,
        zipCode: zipCode,
        range: selectedRadius,
        status: status,
        saleRep: newSaleRep
      });
    } else {
      const newSaleRep = saleRep.filter(s => s !== saleRepValue);
      setSaleRep(newSaleRep);
      handleContactSearch({
        searchValue: searchValue,
        zipCode: zipCode,
        range: selectedRadius,
        status: status,
        saleRep: newSaleRep
      });
    }
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);

    // Pass both search value and zip code to parent
    handleContactSearch({
      searchValue: newSearchValue,
      zipCode: zipCode,
      range: selectedRadius,
      status: status,
      saleRep: saleRep
    });
  };

  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const zipValue = e.target.value;
    setZipCode(zipValue);

    handleContactSearch({
      searchValue: searchValue,
      zipCode: zipValue,
      range: selectedRadius,
      status: status,
      saleRep: saleRep
    });
  };

  const handleRadiusChange = (radius: string) => {
    const rangeValue = radius
    setSelectedRadius(rangeValue);
    handleContactSearch({
      searchValue: searchValue,
      zipCode: zipCode,
      range: rangeValue,
      status: status,
      saleRep: saleRep
    });
  };


  const toggleAdvancedSearch = () => {
    if (showAdvancedSearch) {
      setShowAdvancedSearch(!showAdvancedSearch);
      setZipCode('');
      setSelectedRadius('3');
      setStatus([]);
      handleContactSearch({
        searchValue: searchValue,
        zipCode: '',
        range: '3',
        status: [],
        saleRep: []
      });
    } else {
      setShowAdvancedSearch(!showAdvancedSearch);
    }
  };

  const hideAdvancedSearchLabel = () => {
    setShowAdvancedSearch(!showAdvancedSearch);
  };

  const onClearSearch = () => {
    const newSearchValue = "";
    setSearchValue(newSearchValue);

    // Pass both search value and zip code to parent
    handleContactSearch({
      searchValue: newSearchValue,
      zipCode: zipCode,
      range: selectedRadius,
      status: status,
      saleRep: saleRep
    });
  }

  return (
    <>
      {isView
        ? (<>
          <div className="relative flex-1 w-full min-h-[calc(100vh-212px)] max-h-[calc(100vh-212px)] sm:min-h-[calc(100vh-210px)] sm:max-h-[calc(100vh-210px)] mx-auto mb-2 sm:mb-4 p-3 sm:p-6 bg-white shadow-md rounded-lg">
            {Array.isArray(contactsTemp) && contactsTemp.length > 0 ? (
              <>
                <div className="flex items-center mb-4">
                  <span className='ms-2 font-bold'>
                    {contactsTemp.length > 0
                      ? `(${contactsTemp.length} contacts selected)${contactsTemp.length > 1 ? '' : ''}`
                      : ""}
                  </span>
                </div>

                {/* Contact List */}
                <div className="space-y-2 overflow-y-auto" style={{ minHeight: '120px', maxHeight: 'calc(100vh - 400px)' }}>
                  {contactsTemp.map((contact: any) => (
                    <div key={contact.id} className="flex items-start gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer transition-colors">
                      <input
                        type="checkbox"
                        checked={contactsTemp.some((selected) => selected.id === contact.id || selected.email === contact.email)}
                        disabled={isView}
                        className="w-4 h-4 mt-1 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0"
                      />
                      <div className="min-w-0 flex-1">
                        <p className="text-xs sm:text-sm font-medium text-gray-900 truncate">{contact.name}</p>
                        <p className="text-xs text-gray-500 truncate">{contact.email}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="noresult">
                  <div className="py-6 text-center">
                    <Info className="size-6 mx-auto text-slate-500 fill-sky-100 dark:sky-500/20" />
                    <h6 className="mt-2 mb-1 text-sm sm:text-base">No contacts were included in this draft campaign</h6>
                  </div>
                </div>
              </>
            )}
          </div>
        </>)
        :
        (<>
          <div className="relative flex-1 w-full min-h-[calc(100vh-212px)] max-h-[calc(100vh-212px)] sm:min-h-[calc(100vh-210px)] sm:max-h-[calc(100vh-210px)] mx-auto mb-2 sm:mb-4 p-3 sm:p-6 bg-white shadow-sm rounded-lg">
            {showAdvancedSearch && (
              <div className='absolute top-0 right-0 sm:right-[-258px] z-10 bg-slate-200 py-4 sm:py-6 px-3 sm:px-4 rounded-md overflow-auto w-full sm:w-auto'>
                {/* Advanced Search Row */}
                <div className='text-end cursor-pointer hover:text-gray-600 transition-colors' onClick={hideAdvancedSearchLabel}>
                  <X className="size-5 inline-block" />
                </div>
                <hr />
                <h6 className='mb-2 text-sm'>Search by zipcode</h6>
                <div className='relative flex-1 mb-1'>
                  <input
                    type="text"
                    value={zipCode}
                    className="ltr:pl-8 rtl:pr-8 w-full search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 text-sm"
                    placeholder="Enter zip code"
                    autoComplete="off"
                    onChange={handleZipCodeChange}
                  />
                  <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                </div>

                {/* Range Options Row */}
                <div>
                  <div className="flex flex-col items-start gap-2">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="radius"
                        value="3"
                        checked={zipCode !== '' && selectedRadius === '3'}
                        onChange={(e) => handleRadiusChange(e.target.value)}
                        className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                      />
                      <span className="text-sm font-medium text-slate-700 dark:text-zink-200">3 miles</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="radius"
                        value="5"
                        checked={zipCode !== '' && selectedRadius === '5'}
                        onChange={(e) => handleRadiusChange(e.target.value)}
                        className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                      />
                      <span className="text-sm font-medium text-slate-700 dark:text-zink-200">5 miles</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="radius"
                        value="10"
                        checked={zipCode !== '' && selectedRadius === '10'}
                        onChange={(e) => handleRadiusChange(e.target.value)}
                        className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                      />
                      <span className="text-sm font-medium text-slate-700 dark:text-zink-200">10 miles</span>
                    </label>
                  </div>
                </div>

                {/* Status Options Row */}
                <div onClick={() => {
                  setShowStatusDropdown(!showStatusDropdown);
                  setShowSaleRepDropdown(false);
                }} className="flex items-center justify-between mb-1 mt-4 cursor-pointer transition-colors hover:bg-gray-300 p-1 rounded">
                  <h6 className='mb-0 text-sm'>Select Status</h6>
                  <button
                    type="button"
                    className="hover:bg-gray-200 rounded transition-colors"
                  >
                    {showStatusDropdown ? (
                      <ChevronUp className="w-4 h-4" />
                    ) : (
                      <ChevronDown className="w-4 h-4" />
                    )}
                  </button>
                </div>
                {showStatusDropdown && (
                  <div className="min-h-[200px] sm:min-h-[calc(100vh-500px)] h-[300px] sm:h-[calc(100vh-485px)] overflow-y-auto scrollbar-none">
                    <div className="flex flex-col items-start gap-2">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={status.length === STATUS_OPTIONS.length}
                          onChange={() => {
                            const allSelected = status.length === STATUS_OPTIONS.length;
                            const newStatus = allSelected ? [] : STATUS_OPTIONS.map(option => option.value);
                            setStatus(newStatus);
                            handleContactSearch({
                              searchValue: searchValue,
                              zipCode: zipCode,
                              range: selectedRadius,
                              status: newStatus,
                              saleRep: saleRep
                            });
                          }}
                          className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                        />
                        <span className="text-xs">Select All</span>
                      </label>
                      {STATUS_OPTIONS.map((option) => (
                        <label key={option.value} className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            value={option.value}
                            checked={status.includes(option.value)}
                            onChange={(e) => handleStatusChange(option.value, e.target.checked)}
                            className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                          />
                          <span className="text-sm font-medium text-slate-700 dark:text-zink-200">{option.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}

                {/* Sale Rep Options Row */}
                <div onClick={
                  () => {
                    setShowSaleRepDropdown(!showSaleRepDropdown);
                    setShowStatusDropdown(false);
                  }} className="flex items-center justify-between mb-2 mt-2 cursor-pointer transition-colors hover:bg-gray-300 p-1 rounded">
                  <h6 className='mb-0 text-sm'>Select Sale Rep</h6>
                  <button
                    type="button"
                    className="hover:bg-gray-200 rounded transition-colors"
                  >
                    {showSaleRepDropdown ? (
                      <ChevronUp className="w-4 h-4" />
                    ) : (
                      <ChevronDown className="w-4 h-4" />
                    )}
                  </button>
                </div>
                {showSaleRepDropdown && (
                  <div className="min-h-[200px] sm:min-h-[calc(100vh-500px)] h-[300px] sm:h-[calc(100vh-485px)] overflow-y-auto scrollbar-none">
                    <div className="flex flex-col items-start gap-2">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={saleRep.length === saleRepOptions.length}
                          onChange={() => {
                            const allSelected = saleRep.length === saleRepOptions.length;
                            const newSaleRep = allSelected ? [] : saleRepOptions.map(option => option.id);
                            setSaleRep(newSaleRep);
                            handleContactSearch({
                              searchValue: searchValue,
                              zipCode: zipCode,
                              range: selectedRadius,
                              status: status,
                              saleRep: newSaleRep
                            });
                          }}
                          className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                        />
                        <span className="text-xs">Select All</span>
                      </label>
                      {saleRepOptions.map((option: any) => (
                        <label key={option.name} className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            value={option.id}
                            checked={saleRep.includes(option.id)}
                            onChange={(e: any) => handleSaleRepChange(option.id, e.target.checked)}
                            className="w-4 h-4 text-custom-500 border-slate-300 dark:border-zink-500 focus:ring-custom-500"
                          />
                          <span className="text-sm font-medium text-slate-700 dark:text-zink-200">{option.name}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}

              </div>
            )}
            <div className="mb-4">
              {/* Search Row */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
                <div className="relative flex-1">
                  <input
                    type="text"
                    value={searchValue}
                    className="ltr:pl-8 rtl:pr-8 w-full search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 text-sm"
                    placeholder="Search for contact name or email"
                    autoComplete="off"
                    onChange={handleSearchChange}
                  />
                  <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  <X
                    className="inline-block size-4 absolute ltr:right-2.5 rtl:left-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600 cursor-pointer hover:text-slate-700 dark:hover:text-zink-100"
                    onClick={onClearSearch}
                  />
                </div>

                <button
                  type="button"
                  onClick={toggleAdvancedSearch}
                  className="w-full sm:w-[180px] text-center justify-center flex items-center gap-1 px-3 py-2 text-xs sm:text-sm font-medium text-white dark:text-zink-200 bg-custom-500 dark:bg-zink-600 border border-slate-200 dark:border-zink-500 rounded-md hover:bg-custom-600 dark:hover:bg-zink-700 focus:outline-none transition-colors"
                >
                  {showAdvancedSearch ? 'Clear Advanced Search' : 'Show Advanced Search'}
                </button>
              </div>
            </div>

            {Array.isArray(filteredContact) && filteredContact.length > 0 ? (
              <>
                {/* Select All Checkbox */}
                <div
                  className="flex items-center mb-4 p-2 hover:bg-gray-50 rounded cursor-pointer transition-colors"
                  onClick={(e) => {
                    handleSelectAll();
                    e.stopPropagation();
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => {
                      handleSelectAll();
                      e.stopPropagation();
                    }}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label className="ml-2 text-xs sm:text-sm text-gray-600 cursor-pointer">{contactsSelected.length === 0 ? 'Select all' : contactsSelected.length > 0 && contactsSelected.length === filteredContact.length ? 'Select all' : 'Select more'}</label>
                  <span className='ms-2 font-bold'>
                    {contactsSelected.length > 0
                      ? `(${contactsSelected.length} contacts selected)${contactsSelected.length > 1 ? '' : ''}`
                      : ""}
                  </span>
                </div>

                {/* Contact List */}
                <div className="space-y-2">
                  <InfiniteScroll
                    dataLength={filteredContact.length}
                    next={onLoadMore}
                    hasMore={hasMore}
                    loader={<div className="p-2 text-center text-slate-400"><div className="mt-3"><Loading size="sm" color="blue" isVisible={loadingContacts} /></div></div>}
                    height="calc(100vh - 400px) sm:calc(100vh - 400px)"
                    scrollThreshold={0.99}
                    style={{ minHeight: '120px', maxHeight: 'calc(100vh - 470px)' }}
                  >
                    {filteredContact.map((contact: any) => (
                      <div
                        key={contact.id}
                        className="flex items-start gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer transition-colors"
                        onClick={(e) => {
                          handleContactSelect(contact);
                          setShowErrorSelectContact(false);
                          e.stopPropagation();
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={contactsSelected.some((selected) => selected.id === contact.id)}
                          onChange={(e) => {
                            handleContactSelect(contact);
                            setShowErrorSelectContact(false);
                            e.stopPropagation();
                          }}
                          className="w-4 h-4 mt-1 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0"
                        />
                        <div className="min-w-0 flex-1">
                          <p className="text-xs sm:text-sm font-medium text-gray-900 truncate">{contact.name}</p>
                          <p className="text-xs text-gray-500 truncate">{channelType === ChannelType.Email
                            ? contact.email : channelType === ChannelType.SMS
                              ? contact.phoneNumber : `${contact.email} ${contact.phoneNumber ? `| ${contact.phoneNumber}` : ''}`}</p>
                        </div>
                      </div>
                    ))}
                  </InfiniteScroll>
                  {/* Contact Count */}
                  <div className="mt-4 absolute bottom-[10px] left-[20px] text-xs sm:text-sm text-gray-600">
                    Total contacts: {totalContacts || 0}
                  </div>
                </div>
                {showErrorSelectContact ? (
                  <div className="text-red-500 text-xs sm:text-sm mt-2">You must select at least one contact for sending</div>
                ) : null}
              </>
            ) : (
              <div className="noresult">
                <div className="py-6 text-center">
                  <Search className="size-6 mx-auto text-slate-500 fill-sky-100 dark:sky-500/20" />
                  <h6 className="mt-2 mb-1 text-sm sm:text-base">No contacts available</h6>
                </div>
              </div>
            )}
          </div>
        </>)
      }
    </>
  )
}

export default ContactStep;
